module.exports = __webpack_public_path__ + "img/cancelled_pickup.d84084dc.svg";